module.exports = __webpack_public_path__ + "67c78eaae55335e90ee4a235b0824c0c.svg";